import Vue from "vue";
import moment from "moment";
moment.locale("pt-br");

import can from "./can";
import { routeFrom, routeBack } from "./routeFrom";

Vue.prototype.$can = can;
Vue.prototype.$routeFrom = routeFrom;
Vue.prototype.$routeBack = routeBack;
